import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchWithAuth } from '../../utils/authUtils';
import { formatVnd, shopOrderStatusColor, shopOrderStatusLabel } from '../../constants/shopOrderStatus';
import './MyOrdersPage.css';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

const MyOrdersPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [orders, setOrders] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [detail, setDetail] = useState(null);
  const [error, setError] = useState('');

  const load = async () => {
    setError('');
    try {
      const response = await fetchWithAuth(`${API_BASE}/api/shop/orders`);
      const data = await response.json();
      if (!data.success) {
        setError(data.message || 'Không tải được đơn hàng');
        return;
      }
      setOrders(data.data || []);
    } catch (_) {
      setError('Không kết nối được máy chủ');
    }
  };

  useEffect(() => { load(); }, []);

  const openOrder = async (id) => {
    if (openId === id) {
      setOpenId(null);
      setDetail(null);
      return;
    }
    const response = await fetchWithAuth(`${API_BASE}/api/shop/orders/${id}`);
    const data = await response.json();
    if (data.success) {
      setOpenId(id);
      setDetail(data.data);
    }
  };

  const cancelOrder = async (id) => {
    const response = await fetchWithAuth(`${API_BASE}/api/shop/orders/${id}/cancel`, { method: 'POST' });
    const data = await response.json();
    if (!data.success) {
      setError(data.message || 'Không hủy được đơn');
      return;
    }
    setDetail(data.data);
    load();
  };

  return (
    <div className="my-orders-page">
      <div className="my-orders-card">
        <button type="button" className="checkout-back" onClick={() => navigate('/shop/products')}>Quay lại cửa hàng</button>
        <h1>Đơn hàng của tôi</h1>
        {location.state?.createdCode ? <p className="order-created">Đã tạo đơn {location.state.createdCode}. Đơn đang chờ admin xác nhận.</p> : null}
        {error ? <p className="checkout-error">{error}</p> : null}
        {!orders.length ? <p className="order-empty">Bạn chưa có đơn hàng.</p> : orders.map((order) => {
          const opened = openId === order.id && detail;
          return (
          <article key={order.id} className={`order-card ${opened ? 'is-open' : ''}`}>
            <button type="button" className="order-row-head" onClick={() => openOrder(order.id)}>
              <span className="order-field">
                <span className="order-label">Mã đơn</span>
                <strong>{order.order_code}</strong>
              </span>
              <span className="order-field">
                <span className="order-label">Trạng thái</span>
                <span className="order-status" style={{ background: shopOrderStatusColor(order.status) }}>{shopOrderStatusLabel(order.status)}</span>
              </span>
              <span className="order-field">
                <span className="order-label">Tổng thanh toán</span>
                <strong className="order-money">₫{formatVnd(order.total_vnd)}</strong>
              </span>
              <span className="order-field">
                <span className="order-label">Ngày đặt</span>
                <span>{new Date(order.created_at).toLocaleString('vi-VN')}</span>
              </span>
            </button>
            {opened ? (
              <div className="order-detail">
                <div className="order-detail-grid">
                  <div>
                    <span className="order-label">Người nhận</span>
                    <p>{detail.receiver_name}</p>
                    <p>{detail.receiver_phone}</p>
                  </div>
                  <div>
                    <span className="order-label">Địa chỉ</span>
                    <p>{detail.receiver_address}</p>
                  </div>
                  <div>
                    <span className="order-label">Thanh toán</span>
                    <p>
                      Phí ship:{' '}
                      {Number(detail.shipping_fee) > 0
                        ? `₫${formatVnd(detail.shipping_fee)}`
                        : 'Miễn phí'}
                    </p>
                    <p>Tổng: ₫{formatVnd(detail.total_vnd)}</p>
                  </div>
                </div>
                {detail.note ? <p className="order-note">Ghi chú: {detail.note}</p> : null}
                <span className="order-label">Sản phẩm</span>
                <ul className="order-items">
                  {(detail.items || []).map((item) => (
                    <li key={item.id}>
                      <span>{item.product_name}</span>
                      <span>× {item.quantity}</span>
                      <span>₫{formatVnd(Number(item.unit_price) * Number(item.quantity))}</span>
                    </li>
                  ))}
                </ul>
                {detail.status === 'pending' ? (
                  <button type="button" className="order-cancel" onClick={() => cancelOrder(order.id)}>Hủy đơn</button>
                ) : null}
              </div>
            ) : null}
          </article>
          );
        })}
      </div>
    </div>
  );
};

export default MyOrdersPage;
